import React from 'react';
import { useAuth } from '@/contexts/AuthContext';

interface ErrorBoundaryState { hasError: boolean; error?: any; }
interface ErrorBoundaryProps { children: React.ReactNode; isAdmin?: boolean; }

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error: any): ErrorBoundaryState {
    return { hasError: true, error };
  }
  componentDidCatch(error: any, info: any) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught', error, info);
  }
  handleReload = () => { window.location.reload(); };
  handleGoDashboard = () => { window.location.href = '/dashboard'; };
  render() {
    if (this.state.hasError) {
      if (this.props.isAdmin) {
        return (
          <div className="p-6 text-sm flex flex-col gap-4 items-start" style={{fontFamily:'sans-serif'}}>
            <h2 className="text-lg font-semibold">Something went wrong.</h2>
            <pre className="bg-black/10 dark:bg-white/10 p-3 rounded max-w-full overflow-auto text-xs" style={{whiteSpace:'pre-wrap'}}>
              {String(this.state.error)}
            </pre>
            <div className="flex gap-3">
              <button className="green" onClick={this.handleReload}>Reload Page</button>
              <button className="jet" onClick={this.handleGoDashboard}>Back To Dashboard</button>
            </div>
          </div>
        );
      }
      // Non-admin: show only a safe navigation button without error details
      return (
        <div className="p-6 flex flex-col items-start" style={{fontFamily:'sans-serif'}}>
          <button className="jet" onClick={this.handleGoDashboard}>Back To Dashboard</button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Wrapper to inject isAdmin via hook since class component can't use hooks directly
const ErrorBoundaryWithAuth: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const { user } = useAuth();
  return <ErrorBoundary isAdmin={!!user?.is_admin}>{children}</ErrorBoundary>;
};

export default ErrorBoundaryWithAuth;
export { ErrorBoundary };
